import { useMemo } from "react";
import { useGetVehiclesQuery } from "../../../entities/vehicle/api/api.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../entities/vehicle/model/selectors/selectVehicleParameters.js";
import "react-redux";
import "../../benefitChoice/model/index.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "@perxis-auto/shared";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import "../../filterValues/api/api.js";
import "../../filterValues/model/middleware/index.js";
import "../../filterValues/model/selectors/selectAllFilterValues.js";
import "../../filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../filterValues/model/selectors/selectFilterItemByKey.js";
import "../../filterValues/model/selectors/selectFilterItems.js";
import "../../filterValues/model/selectors/selectFilterValuesFields.js";
import "../../filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../filterValues/model/selectors/selectIsFilterValuesMissing.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/installation/middleware/index.js";
import "../../../entities/vehicle/model/selectors/selectIsVehiclesDataMissing.js";
import "../../../entities/vehicle/model/selectors/selectVehicle.js";
import "../../../entities/vehicle/model/selectors/selectVehicles.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesCount.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesParameters.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesTotalPages.js";
import { selectors } from "../model/index.js";
const useGetComparableVehicles = () => {
  const comparableVehiclesParameters = useAppSelector(selectors.selectComparableVehiclesParameters);
  const comparisonEntities = useAppSelector((state) => selectors.selectEntities(state.comparison));
  const selectedComparisonItems = useAppSelector(selectors.selectSelected);
  const queryResult = useGetVehiclesQuery(comparableVehiclesParameters);
  const { currentData, data: vehiclesData = currentData } = queryResult;
  const selectedComparableVehicles = useMemo(() => {
    if (!vehiclesData || !selectedComparisonItems.length) {
      return;
    }
    return selectedComparisonItems.reduce((acc, selectedItemId) => {
      const selectedVehicle = vehiclesData.items.find((i) => i.id === selectedItemId);
      if (!selectedVehicle) {
        return acc;
      }
      return [...acc, selectedVehicle];
    }, []);
  }, [vehiclesData, selectedComparisonItems]);
  const sortedComparableVehicles = useMemo(() => {
    if (!vehiclesData) {
      return;
    }
    return [...vehiclesData.items].filter((vehicle) => !!comparisonEntities[vehicle.id]).sort((a, b) => {
      return comparisonEntities[a.id].addedBy - comparisonEntities[b.id].addedBy;
    });
  }, [vehiclesData, comparisonEntities]);
  return useMemo(
    () => ({
      ...queryResult,
      preparedData: {
        selectedComparableVehicles,
        sortedComparableVehicles
      }
    }),
    [queryResult, selectedComparableVehicles, sortedComparableVehicles]
  );
};
export {
  useGetComparableVehicles
};
